import { gql } from '@apollo/client';

export const DeleteFundScenarioInvestmentScenarios = gql`
  mutation DeleteFundScenarioInvestmentScenarios($scenarios: [UUID]!) {
    fundScenarioInvestmentScenariosDelete(scenarios: $scenarios)
  }
`;
